module.exports = __webpack_public_path__ + "static/media/loans-icon.46df840c.svg";